// extracted by mini-css-extract-plugin
module.exports = {"boxes":"organizationsSeats_boxes__3OX-F","icon":"organizationsSeats_icon__nKRvI"};